import React from 'react';
import LottieAnimation from '@/components/behaviours/LottieAnimation';
import Icon from '@/components/atoms/Icon';
import animationData from './LottiePhoneRotate.json';

const PhoneRotate = (props) => (
    <Icon iconName="PhoneRotate" {...props}>
        <LottieAnimation loop autoplay animationData={animationData} />
    </Icon>
);

export default PhoneRotate;
